// data sources for set metrics.
// 'Catapult', 'Match Stats', and 'Player Entered' are external feeds ingested
// via the AMS cricket webhook. 'Manual Override' marks a practitioner-entered
// value: every set-metric edit made on a practitioner surface (bowling block
// summary, bulk actuals page, and their server-side fan-out) carries this
// stamp, so it outranks every feed on merge regardless of sync order. Athlete
// entry surfaces (tablet mode, mobile) save un-stamped (no dataSource).
// 'Prescription' is a merge-only sentinel — never stored in the DB. It is
// temporarily assigned to prescription-layer setMetrics before merging so
// that actual-layer data (even user-entered null) wins over the prescription.
// It is stripped back to undefined immediately after the merge completes.
export const DataSources = [
    'Catapult',
    'Match Stats',
    'Player Entered',
    'Manual Override',
    'Prescription',
];
export function defaultLayer(layer = {}) {
    return {
        removals: [],
        sectionAdds: [],
        sectionEdits: [],
        supersetAdds: [],
        supersetEdits: [],
        supersetExerciseAdds: [],
        supersetExerciseEdits: [],
        alternateGroupAdds: [],
        alternateGroupEdits: [],
        alternateExerciseAdds: [],
        alternateExerciseEdits: [],
        exerciseAdds: [],
        exerciseEdits: [],
        exerciseMetricAdds: [],
        setAdds: [],
        setEdits: [],
        setMetrics: [],
        ...layer,
    };
}
//# sourceMappingURL=layer.js.map